import { useMemo } from 'react';
import { DataGrid, GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Patient } from '../../../../../domain/entities';

interface Props {
  patients: Patient[];
  onPatientDeleted: (id?: string) => void;
  onEditPatient: (id?: string) => void;
}

export default function PatientsDataGrid({ patients, onPatientDeleted, onEditPatient }: Props) {
  const getAge = (params: GridValueGetterParams<Patient>) => {
    const today = new Date();
    const diff = today.getTime() - params.row.birthDate.getTime();
    const millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
    const age = Math.floor(diff / millisecondsInYear);
    return age.toString();
  };

  const columns = useMemo<Array<GridColDef<Patient>>>(
    () => [
      { field: 'ssn', headerName: 'Cédula', type: 'string', flex: 1 },
      { field: 'name', headerName: 'Nombre', type: 'string', flex: 1 },
      {
        field: 'age',
        headerName: 'Edad',
        type: 'string',
        flex: 1,
        valueGetter: getAge
      },
      { field: 'phone', headerName: 'Teléfono', type: 'string', flex: 1 },
      { field: 'email', headerName: 'Email', type: 'email', flex: 1 },
      { field: 'city', headerName: 'Ciudad', type: 'string', flex: 1 },
      {
        field: 'actions',
        type: 'actions',
        flex: 1,
        align: 'right',
        getActions: (params) => [
          <GridActionsCellItem
            key={'edit'}
            icon={<EditIcon />}
            label='edit'
            onClick={() => onEditPatient(params.row.id)}
          />,
          <GridActionsCellItem
            key={'delete'}
            icon={<DeleteIcon />}
            label='Delete'
            onClick={() => onPatientDeleted(params.row.id)}
          />
        ]
      }
    ],
    [onPatientDeleted, onEditPatient]
  );

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <DataGrid columns={columns} rows={patients} />
    </div>
  );
}
